import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-bin-locations/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-bin-locations/$id')({
  pendingComponent: Loading,
});
